'use strict';
/**
 * @doc module
 * @name globalFilters
 * @description
 *
 * global filters used across the system.
 */

var nodeDummyAngular = {
  module: function(){},
  filter: function(){},
  factory: function(){}
};

var angular;
if (typeof window !== "undefined") {
    angular = window.angular;
}
angular = angular || nodeDummyAngular;

var app = app || angular.module('harriApp') || nodeDummyAngular;

var globalFilters = {};

if (typeof(MediaUtils) != 'undefined') {
    MediaUtils.registerFilters(app);
}

if (typeof(DocUtils) != 'undefined') {
    DocUtils.registerFilters(app);
}

app.filter('fullDateTime', function() {
  return function(timestamp) {
    return moment(timestamp, "X").format('MMMM Do YYYY, h:mm:ss a');
  }
});

/* this filter was added for checking text not wrapped in translate filter it should be modifed later when the process is done */
app.filter("translate", ['$state', 'localize', function ($state, localize) {
    return function (content) {
        if (localize.isRouteDisabled($state.current.name)) return content;
        return lang[content] || content;
    }
}]);

app.filter('vowelprepend', function() {
  return function(word) {

    if (word) {
      var vowelArray = ['a', 'e', 'i', 'o', 'u'];
      if( vowelArray.indexOf(word.charAt(0).toLowerCase()) >= 0 ){
        return "an";
      }
      return "a";
    }
  }
});

app.filter('fromNow', function(){
  return function(date) {
    return moment().from( date ,true);
  }
});

app.filter('formatDate', function(){
  return function(time, format){
    return moment(time).format(format);
  }
});

// This formats the date with ignoring the time zone of the user who is using the system
app.filter('formatDateIgnoreTimeZone', function(){
    return function(time, format){
        if(isNaN(Date.parse(time))) {
            return;
        }
        return moment(time).zone(0).format(format || "YYYY-MM-DDTHH:mm:ss");
    };
});

app.filter('formatDateFromNow', function () {
    return function (time) {
        return moment(time).fromNow();
    }
});

app.filter('formatDateFromNowDays', function(){
  return function(time){
    ///12/15/14
    return moment().add(time, 'd').format('MMM DD, YYYY');
  }
});

app.filter('formatHours', function () {
    return function (time, showSeconds, timeFormat, forExcel) {
        if (timeFormat == 'HOUR') {
            if (time) {
                var hours = (time / 3600).toFixed(2);
                return hours;
            }
            return "0.0";
        }
        else {
            if (time) {
                var isNegative = false;
                if(time < 0 ){
                    isNegative = true;
                    time = time * -1;
                }
                var hours = Math.floor(time / 3600);
                hours = hours < 10 ? '0' + hours : hours;
                var minutes = Math.floor((time % 3600) / 60);
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var seconds = parseInt((time % 3600) % 60);
                seconds = seconds < 10 ? '0' + seconds : seconds;
                var value = hours + ":" + minutes + (showSeconds ? ":" + seconds : "");
                if (isNegative) {
                    if (forExcel) {
                        return "(" + value + ")";
                    }
                    else {
                        return "-" + value;
                    }
                }
                else {
                    return value;
                }
            }
            return "00:00" + (showSeconds ? ":00" : "");
        }
    }
});

app.filter('dateDifferenceSeconds', function () {
    return function (start, end) {
        return (moment.duration(moment(end).diff(moment(start))).asSeconds());
    }
});

app.filter('dateDifferenceAsDays', function () {
    return function (start, end) {
        return Math.round(moment.duration(moment(end).diff(moment(start))).asDays());
    }
});

app.filter('formatPhone', function(){
  return function(phone){
      if (isNaN(phone)) {
          return phone;
      }
      if (phone && phone.length < 10) {
          return phone;
      }
      if (phone && phone.length < 13) {
          var phoneNumber = phone.split("").reverse().join("");
          phoneNumber = phoneNumber.slice(0, 4) + '-' + phoneNumber.slice(4, 7) + '-' + phoneNumber.slice(7, 10) + ' ' + phoneNumber.slice(10, phoneNumber.length);
          return phoneNumber.split("").reverse().join("");
      }
      return phone;
  }
});

globalFilters['userPosition'] = function(workObj, notTranslated) {
  var returnedStr = "";

    if (workObj) {
        if (workObj.custom_position && workObj.custom_position != "") {
            returnedStr = workObj.custom_position;
        } else if (workObj.Position) {
            if (workObj.Position.name) {
                // $filter is not defined in Node.js side
                returnedStr = notTranslated ? workObj.Position.name : (typeof $filter !== 'undefined' && $filter('translate')(workObj.Position.name)) || workObj.Position.name;

            } else if (workObj.Position[0] && workObj.Position[0].name) {
                // $filter is not defined in Node.js side
                returnedStr = notTranslated ? workObj.Position[0].name :(typeof $filter !== 'undefined' && $filter('translate')(workObj.Position[0].name)) || workObj.Position[0].name;
            }
        }
    }

  return returnedStr;
};
app.filter('compactNumber', ['$filter', function ($filter) {
    return function (number, currency) {
        return Utils.compactNumber(number, currency);
    }
}]);

app.filter('userPosition' , function(){
  return globalFilters['userPosition'];
});

globalFilters['escapeDoubleCurlyBrackets'] = function (str) {
    var result = str || "";
    var matches = result.match(/\{{(.*?)\}}/g);
    if (!matches) {
        return result;
    }
    var tokens = matches.map(function (item) {
        return item;
    });
    for (var i = 0; i < tokens.length; i++) {
        result = result.replace(tokens[i], "{{'\\{\\{" + tokens[i].replace('{{', '').replace('}}', '') + "\\}\\}'}}");
    }
    return result;
};

globalFilters['URLtoBackgroundImage'] = function (str) {
    return (str && 'background-image:url(' + str + ')');
};

app.filter('URLtoBackgroundImage' , function(){
    return globalFilters['URLtoBackgroundImage'];
});

globalFilters['jobUrl'] = function(brandSlug, jobId, positionName) {
    var jobUrl = "",
        jobId_with_jobName = "";

    if (!brandSlug || !jobId ) {
        console.error("No brand-slug or job-id found !!");
        return;
    }

    jobId_with_jobName = jobId + " ";

    jobId_with_jobName = jobId_with_jobName + positionName;
    jobId_with_jobName = jobId_with_jobName.replace(/[^a-zA-Z_0-9_\-.]+/g, " ").trim().replace(/\s+/g, "-").toLowerCase();

    jobUrl = brandSlug + '/job/' + jobId_with_jobName;

    return jobUrl;
};

app.filter('jobUrl' , function(){
    return globalFilters['jobUrl'];
});


app.filter('cut', function () {
    return function (value, wordwise, max, tail) {
        if (!value) return '';

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);
        if (wordwise) {
            var lastspace = value.lastIndexOf(' ');
            if (lastspace != -1) {
                value = value.substr(0, lastspace);
            }
        }

        return value + (typeof(tail) == "undefined"?' …':tail);
    };
});

app.filter('firstChar', function () {
    return function (value) {
        return Utils.firstChar(value);
    }
});

app.filter('stringToColor', function () {
    return function (value) {
        return Utils.stringToColor(value);
    }
});

app.filter('jobEndTime', function(){
  return function( date ){
    var endTime = moment(date).add( 1 , 'month' );
    var today = moment();

    return endTime.diff( today , 'days' );
  }
});

/**
 *
 * Angular:
 *     JS:
 *     $filter('formatLocation')({
           "City": {
             "code": "Pyrmont",
             "id": 3,
             "name": "Pyrmont"
           },
           "Country": {
             "code": "US",
             "id": 1,
             "name": "United States"
           },
           "State": {
             "code": "California",
             "id": 1,
             "name": "California"
           },
           "created": "2014-09-07T16:30:42",
           "formatted_address": "48 Pirrama Road, Pyrmont NSW, Australia",
           "id": 302,
           "latitude": -33.867,
           "longitude": 151.196,
           "postal_code": 2009,
           "street": "Cynthia",
           "suite": "48",
           "updated": "2014-09-07T16:30:42"
         }, 'long')

      Template:
      location|formatLocation:""

    nunjucks:

    {{location|formatLocation("long")}} or {{location|formatLocation("short")}}

 */

/**
 * @param location
 * @param type
 * @param ufaisim: Use formatted address if street is missing.
 * @returns {*}
 */
globalFilters['formatLocation'] = function (location, type, ufaisim) {
    if (!location) {
        return '';
    }

    var formattedAddrress = location.formatted_address;
    var street = location.street;
    var city = location.City && (location.City.name || (location.City[0] && location.City[0].name));
    var state = location.State && (location.State.name || (location.State[0] && location.State[0].name));
    var country = location.Country && (location.Country.name || (location.Country[0] && location.Country[0].name));
    var address = [];

    if (type === 'formatted_address') {
        return formattedAddrress;
    }

    if (type === 'long') {
        if (city) {
            address.push(city);
        }

        if (state) {
            address.push(state);
        }

        if (country) {
            address.push(country);
        }
    } else {
        if (street) {
            address.push(street);
        } else if (ufaisim && formattedAddrress) {
            return formattedAddrress;
        }

        if (city) {
            address.push(city);
        }

        if (!city && state) {
            address.push(state);
        }
    }

    if (address.length === 0) {
        address.push(formattedAddrress);
    }

    return address.join(", ");
};

app.filter('formatLocation', function () {
    return globalFilters['formatLocation'];
});

app.filter('formatPeriod', function(){
    return function(months) {
      return moment.duration({'months': months}).humanize();
    }
});


app.filter('formatYearsOfExperience', function () {
    return function (startDate, endDate, label) {
        return Utils.capitalize(moment.duration({'months': moment.duration(moment(endDate ? moment(endDate) : moment()).diff(startDate)).asMonths()}).humanize()) + ' ' + (label || '');
    }
});


globalFilters['formatWorkPeriod'] = function (startdate , enddate, shorten ){
  var start = moment(startdate);
  var end = moment(enddate);

  shorten = shorten || false;


  if (enddate == undefined) {
    end = moment();
  }
  var ms = moment(end,"DD/MM/YYYY HH:mm:ss").diff(moment(start,"DD/MM/YYYY HH:mm:ss"));
  var d = moment.duration(ms);

  // Consider 12 months as a year (default is 11)
  moment.relativeTimeThreshold('M', 12);

    var period = [];
    if (d.years() > 0) {
        var yearsVal;

        if (d.years() === 1) {
            yearsVal = '1 year';
        } else {
            yearsVal = moment.duration(d.years(), 'years').humanize();
        }
        period.push(yearsVal);
    }

    if (d.months() > 0) {
        var monthsVal;

        if (d.months() === 1) {
            monthsVal = '1 month';
        } else {
            monthsVal = moment.duration(d.months(), 'months').humanize();
        }
        period.push(monthsVal);
    }

    var text = period.join(', ');


  if (shorten) {
    text = text.replace('years', 'yrs');
    text = text.replace('year', 'yr');
    text = text.replace('months', 'mo');
  }

  return text;
};

app.filter('formatWorkPeriod',function(){

  return globalFilters['formatWorkPeriod'];

});

app.filter('compensationFormatter', ['$filter', function ($filter) {
    return globalFilters['compensationFormatter']($filter);
}]);

globalFilters['compensationFormatter'] = function($filter) {
    return function(jobCompensation, brand) {
        var result = "";
        var fractionSize = 2;

        var currency = Utils.locationCurrencySymbol(brand);

        if (currency === 'CHF') {
            currency += ' ';
        }

        var compensationCode = jobCompensation['compensation']['code'];
        var compensationName = jobCompensation['compensation']['name'];
        var compensationRate = jobCompensation['compensation_rate'];

        switch (compensationCode) {
            case 'TO_BE_DISCUSSED' :
                result += $filter("translate")(compensationName);
                break;

            case 'MINIMUM_WAGE' :
                result += $filter("translate")(compensationName);
                break;

            case 'COMPETITIVE' :
                result += $filter("translate")("Competitive salary");
                break;

            case 'RANGE' :

                var fromAmount = jobCompensation.compensation_from;
                var toAmount = jobCompensation.compensation_to;

                result += $filter('currency')(fromAmount, currency, fractionSize);
                result += ' - ';
                result += $filter('currency')(toAmount, currency, fractionSize);

                if (compensationRate && compensationRate.name) {
                    result += ' / ' + $filter("translate")(compensationRate.name);
                }
                break;

            case 'UP_TO' :

                var amount_label = jobCompensation.amount_label;
                var fromAmount = jobCompensation.compensation_from;

                result += $filter("translate")(amount_label);
                result += " " + $filter('currency')(fromAmount, currency, fractionSize);

                if (compensationRate && compensationRate.name) {
                    result += ' / ' + $filter("translate")(compensationRate.name);
                }
                break;

            case 'SET_AMOUNT' :

                var fromAmount = jobCompensation.compensation_from;

                result += $filter('currency')(fromAmount, currency, fractionSize);

                if (compensationRate && compensationRate.name) {
                    result += ' / ' + $filter("translate")(compensationRate.name);
                }

                break;
        }


        var pluses = [];
        var withoutPluses = "";

        if (jobCompensation.plus_tips) {
            pluses.push($filter("translate")("Tips"));
        }
        if (jobCompensation.plus_bonus) {
            pluses.push($filter("translate")("Bonus"));
        }
        if (jobCompensation.plus_commission) {
            pluses.push($filter("translate")("Commission"));
        }
        if (jobCompensation.is_ote) {
            withoutPluses += $filter("translate")("OTE, ");
        }
        if (jobCompensation.plus_overtime) {
            pluses.push($filter("translate")("Overtime"));
        }
        if (jobCompensation.plus_company_car) {
            pluses.push($filter("translate")("Company car"));
        }
        if (jobCompensation.plus_live_in_accommodation) {
            pluses.push($filter("translate")("Live in accommodation"));
        }
        if (jobCompensation.fixed_term_contract) {
            withoutPluses += $filter("translate")("Fixed term contract, ");
        }
        if (jobCompensation.field_based) {
            withoutPluses += $filter("translate")("Field based, ");
        }
        if (jobCompensation.mobile_working) {
            withoutPluses += $filter("translate")("Mobile working, ");
        }
        if (jobCompensation.plus_service_charge) {
            pluses.push($filter("translate")("Service Charge"));
        }
        if (jobCompensation.plus_tronc) {
            pluses.push($filter("translate")("Tronc"));
        }

        if (withoutPluses.length || pluses.length) {
            var combinedText = '';
            if (withoutPluses.length) {
                combinedText += withoutPluses.slice(0, withoutPluses.length - 2);
            }
            if (withoutPluses.length && pluses.length) {
                combinedText += ', ';
            }
            if (pluses.length) {
                combinedText += 'Plus ' + pluses.join(' & ');
            }

            if (brand.withInfoIcon) {
                result += ' <i class="fa fa-info-circle" data-original-title="' + combinedText + '" tooltip-angular></i>';
            } else {
                result += '<br />' + combinedText;
            }
        }

        // Remove .00 from numbers e.g. 1,000.00 to 1,000
        return result.replace(/\.00/g, "");
    };
};

/**
 * Format Objects
 */
app.filter('formatObj', function(){
    return function(arr, key){
        return join_obj( arr, key );
    }
});

app.filter('links2anchors', function () {
    return function (msg) {
        if (!msg || typeof msg !== 'string') {
            return msg;
        }

        const allowedDomains = ["com", "org", "net", "edu", "gov", "us", "uk", "ly", "live"];

        // Helper function to check if we're inside an HTML tag or already processed
        const shouldSkipMatch = (text, offset) => {
            const beforeMatch = text.substring(0, offset);

            // Check if we're inside any HTML tag (between < and >)
            const lastTagOpen = beforeMatch.lastIndexOf("<");
            const lastTagClose = beforeMatch.lastIndexOf(">");
            if (lastTagOpen !== -1 && (lastTagClose === -1 || lastTagOpen > lastTagClose)) {
                return true;
            }

            // Check if we're inside any href attribute (handle both single and double quotes)
            const hrefPatterns = [/href\s*=\s*"/gi, /href\s*=\s*'/gi];
            for (const pattern of hrefPatterns) {
                pattern.lastIndex = 0; // Reset regex state
                let match;
                while ((match = pattern.exec(beforeMatch)) !== null) {
                    const hrefStart = match.index + match[0].length;
                    const quote = match[0].slice(-1); // Get the quote character (" or ')
                    const hrefEnd = beforeMatch.indexOf(quote, hrefStart);
                    if (hrefEnd === -1 || offset <= hrefEnd) {
                        return true; // We're inside an unclosed or current href value
                    }
                }
            }

            // Check if this text is already part of an anchor tag's content
            const lastAnchorOpen = beforeMatch.toLowerCase().lastIndexOf("<a ");
            const lastAnchorClose = beforeMatch.toLowerCase().lastIndexOf("</a>");
            if (lastAnchorOpen !== -1 && (lastAnchorClose === -1 || lastAnchorOpen > lastAnchorClose)) {
                return true;
            }

            return false;
        }

        msg = msg.replace(/(?:https?:\/\/[^\s<>]+)|(?:\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b)|(?:\b[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}(?:\/[^\s<>]*)?)/gi, (match, offset) => {
            if (shouldSkipMatch(msg, offset)) { return match; }

            const escapedHref = match.replace(/"/g, '&quot;').replace(/'/g, '&#39;');

            // 1. HTTP/HTTPS URLs
            if (/^https?:\/\//i.test(match)) {
                return "<a href='" + escapedHref + "' target='_blank'>" + match + "</a>";
            }

            // 2. Email addresses
            if (match.indexOf('@') !== -1) {
                const link = match.indexOf('mailto:') === 0 ? match : 'mailto:' + match;
                const escapedEmailHref = link.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
                return "<a href='" + escapedEmailHref + "'>" + match + "</a>";
            }

            // 3. Domain-only URLs
            const linkParts = match.split(".");
            const linkSuffix = linkParts.splice(0, 1)[0];
            let linkPrefix = linkParts.pop();

            const cleanTLD = linkPrefix && linkPrefix.split("/")[0].split("#")[0].split("?")[0].split(":")[0];

            if (linkSuffix && cleanTLD && allowedDomains.indexOf(cleanTLD.toLowerCase()) > -1) {
                const fullUrl = "http://" + match;
                const escapedFullUrl = fullUrl.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
                return "<a href='" + escapedFullUrl + "' target='_blank'>" + match + "</a>";
            }
            
            return match;
        });

        return msg;
    }
});

/**
 * nl2br
 */
app.filter('nl2br', ["$sce", "$sanitize", "truncate", function ($sce, $sanitize, truncate) {
    return function (msg, is_xhtml, allowed) {

        var breakTag = '<br>';
        var allowed = allowed || '<br><a>';

        msg = msg || '';
        msg = msg.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');

        return $sce.getTrustedHtml($sanitize(truncate(msg, allowed)));
    }
}]);

app.factory('truncate', function () {
    return function strip_tags(input, allowed) {
        allowed = (((allowed || '') + '')
            .toLowerCase()
            .match(/<[a-z][a-z0-9]*>/g) || [])
            .join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
            commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
        return input.replace(commentsAndPhpTags, '')
            .replace(tags, function($0, $1) {
                var tagText = $0;

                if ($1 === 'a') {
                    var hrefPattern = /.*href=["']([^>^\"^\']*)["'].*/;
                    var hrefURL = tagText.replace(hrefPattern, '$1');

                    if (hrefURL && hrefURL != tagText) {
                        var tagTarget = '';
                        let classes;
                        let classesMatch = tagText.match(/class=["']([^"']+)["']/);

                        if (classesMatch && classesMatch.length && classesMatch[1]) {
                            classes = "class='" + classesMatch[1] + "' ";
                        }

                        if (tagText.indexOf("_blank") > -1) {
                            tagTarget = "target='_blank'";
                        }

                        tagText = "<a href='" + hrefURL + "' ";
                        if (classes) {
                            tagText += classes;
                        }

                        tagText += tagTarget + ">";
                    }
                }

                return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? tagText : Utils.htmlEntities(tagText);
            });
    }
});


app.filter('calculatePercentage', function(){
  return function( price , originalPrice ){

    /**
     * Return 100% if price == 0
     */
    if( price == 0 ){
      return 100;
    }

    return  parseInt( ( ( originalPrice - price ) / originalPrice ) * 100 ) ;
  }
});


/**
 * Format Credits
 */
app.filter('formatCredits', ['$filter',function($filter){
    return function(credits){
        if(credits >= 1000) {
            return $filter("translate")("Unlimited");
        } else if (credits==0 || !credits) {
            return $filter("translate")("No remaining credits");
        } else {
            return credits + ' '+$filter("translate")("credits left");
        }
    }
}]);


/**
 * Format JopPosts
 */
app.filter('formatJobPostsTitle', ['$filter',function($filter){
    return function(credits){

        if(credits == 1) {
            return $filter("translate")("Job Post");
        } else {
            return $filter("translate")("Job Posts");
        }
    }
}]);
/**
 * Format position to accept in Search
 */

app.filter('termFormatterToSearch', function(){
  return function( term ){
    return encodeURIComponent( encodeURIComponent( term ) );
  }
});


app.filter('formatJobApplyLocations', ['$filter', '$sce', function ($filter, $sce) {
    return function (locations) {

        var groupedLocations = {};
        var result = "";

        if (locations) {

            if (locations.length > 1) {
                var getName = function (locationPart) {
                    return locationPart && locationPart.name;
                };

                var getGroupCriteria = function (location) {
                    var groupCriteria = { code: "", name: ""};
                    var criteriaParts = [];

                    var city = getName(location.city);
                    var state = getName(location.state);
                    var country = getName(location.country);

                    groupCriteria.code = city || state || country || "";
                    groupCriteria.code = groupCriteria.code.toLowerCase();

                    if (city) {
                        criteriaParts.push(city);

                        if (state) {
                            if (city != state) {
                                criteriaParts.push(state);
                            }
                        }
                        else if (country) {
                            criteriaParts.push(country);
                        }
                    }
                    else if (state) {
                        criteriaParts.push(state);
                    }
                    else if (country) {
                        criteriaParts.push(country);
                    }

                    groupCriteria.name = criteriaParts.join(", ");

                    return groupCriteria;
                };

                var getGroupedLocation = function (location) {
                    var street = location.street;

                    var groupCriteria = getGroupCriteria(location);

                    if (!street) {
                        var formattedAddressParts = location.formatted_address.split(", ");
                        var streetNameParts = [];

                        for (var i in formattedAddressParts) {
                            if (formattedAddressParts[i].toLowerCase() != groupCriteria.code) {
                                streetNameParts.push(formattedAddressParts[i]);
                            }
                            else {
                                break;
                            }
                        }

                        street = streetNameParts.join(", ");
                    }

                    if (location.suite) {
                        street = location.suite + " " + street;
                    }

                    groupedLocations[groupCriteria.code] = groupedLocations[groupCriteria.code] || { name: groupCriteria.name, locations: [] };

                    if (street) {
                        groupedLocations[groupCriteria.code].locations.push(street);
                    }
                };

                for (var i in locations) {
                    var location = locations[i].Location;
                    getGroupedLocation(location);
                }

                var resultParts = [];

                for (var code in groupedLocations) {
                    var locationGroup = groupedLocations[code];

                    if (locationGroup.locations.length) {
                        var locationsParts = [];

                        for (var j in locationGroup.locations) {
                            locationsParts.push(locationGroup.locations[j]);
                        }

                        resultParts.push(locationsParts.join(" / ") + " " + $filter("translate")("in") + " " + locationGroup.name);
                    }
                    else {
                        resultParts.push(locationGroup.name);
                    }
                }

                result = $sce.trustAsHtml(resultParts.join("<br/>"));
            }
            else {
                result = locations[0].Location.formatted_address;
            }

        }

        return result;
    }
}]);


/* trust URL */
app.filter('trusted', ['$sce', function ($sce) {
    return function(url) {
        return $sce.trustAsResourceUrl(url);
    };
}]);

/* Format Long Job Location
====================================*/
app.filter('formatLongJobLocation', function(){
  return function( locations){
    var locationArray = [];
    if(locations.length>1){
      for(var i in locations){
        locationArray.push(locations[i].Location.formatted_address);
      }
    }else{
      locationArray.push(locations[0].Location.formatted_address);
    }

    //locationArray.join(', ');


    return locationArray.join(', ');
  }
});

//object with empty data or false data
app.filter('hasEmptyData', function () {
  return function (dataObj) {
    dataObj = angular.copy(dataObj);
    var state = true ; //assume object has empty data
    angular.forEach(dataObj, function(value, key){
      if (value) {
        //object doesn't have empty data
        state = false ;
      }
    });
    return state ;
  };
});

//array of empty objects or objects with false data
app.filter('hasEmptyArrayOfData',["hasEmptyDataFilter", function(hasEmptyDataFilter) {
  return function(leftOvers){
    //assume empty array of data by default
    var state = false;
    angular.forEach(leftOvers, function(item, key) {
      if ( hasEmptyDataFilter(angular.copy(item.data))) {
        state = true;
      }
    });

    return state;
  }
}]);


// Get the name of OnBoarding document
app.filter('obDocName', function () {
    return function (docCode, docName, docSetCode) {

        if (OnBoardingAPI.DOC_TYPE_TEXT[docCode]) {
            return OnBoardingAPI.DOC_TYPE_TEXT[docCode];
        }

        if (docCode === OnBoardingAPI.DOCUMENT_TYPE.CUSTOM_DOCUMENT) {
            return $filter('translate')('Custom document');
        }

        if (docCode === OnBoardingAPI.DOCUMENT_TYPE.FOOD_CERTIFICATION) {
            return $filter('translate')('Food certification');
        }

        if (docCode === OnBoardingAPI.DOCUMENT_TYPE.ALCOHOL_CERTIFICATION) {
            return $filter('translate')('Alcohol certification');
        }

        if (docCode === OnBoardingAPI.DOCUMENT_TYPE.INSURANCE_REGISTRATION) {
            return $filter('translate')('Insurance Registration');
        }

        if (docCode === OnBoardingAPI.DOCUMENT_TYPE.MOTOR_VEHICLE_RECORD) {
            return $filter('translate')('Motor Vehicle Record');
        }

        if (docCode === OnBoardingAPI.DOCUMENT_TYPE.DRIVER_LICENSE) {
            return $filter('translate')('Driver license');
        }

        return docName;
    }
});

// Get the name of OnBoarding document (with extra hints for employer send)
app.filter('obDocNameExtraHint', function () {
    return function (docCode, docName, docSetCode) {

        var name = docName;

       if (OnBoardingAPI.DOC_TYPE_TEXT[docCode]) {
            name = OnBoardingAPI.DOC_TYPE_TEXT[docCode];
        }

        if (['COMMUTER_BENEFITS', 'MEATBALL_SHOP_DC_COMMUTER_BENEFITS', 'DC_COMMUTER_BENEFITS'].indexOf(docCode) > -1) {
            name = name + " (" + $filter("translate")("Optional") + ")";
        }
        else if (docCode == 'AGREEMENT_DIRECT_DEPOSIT' || docCode == 'AGREEMENT_DIRECT_DEPOSIT_CA' || docCode == 'AGREEMENT_DIRECT_DEPOSIT_UNIVERSAL_PAYCARD') {
            name = name + " (" + $filter("translate")("Needs bank information") + ")";
        }

        return name;
    }
});

app.filter('formatPhone', function(){
    return function (phone) {
        if (isNaN(phone)) {
            return phone;
        }
        if (phone && phone.length < 10) {
            return phone;
        }
        if (phone && phone.length < 13) {
            var phoneNumber = phone.split("").reverse().join("");
            phoneNumber = phoneNumber.slice(0, 4) + '-' + phoneNumber.slice(4, 7) + '-' + phoneNumber.slice(7, 10) + ' ' + phoneNumber.slice(10, phoneNumber.length);
            return phoneNumber.split("").reverse().join("");
        }
        return phone;
    }
});

/**
 * get location currency from brand object with locations array
 * return symbol, please send it to ng-bind-html because some symbols are html entity
 */
app.filter('locationCurrencySymbol', function(){
    return function(brand){
        return Utils.locationCurrencySymbol(brand);
    }
});


/**
 * Escape
 */
app.filter('escape', function(){
    return function(input){
        if (typeof(input) === 'string') {
            input = input || '';

            return input.replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }

        return input;
    }
});

/**
 * Ordinal
 * return ordinal form for a number
 * 1 -> 1st, 2 -> 2nd, ...
 */
app.filter('ordinal', function(){
	return function(number){
		number = parseInt(number) || number;
		if(isNaN(number) || number < 1){
			return number;
		} else {
			if (number == 10 || number == 11 || number == 12 || number == 13) {
				return number + 'th'
			}
			else {
				var lastDigit = number % 10;
				if (lastDigit === 1) {
					return number + 'st'
				} else if (lastDigit === 2) {
					return number + 'nd'
				} else if (lastDigit === 3) {
					return number + 'rd'
				} else {
					return number + 'th'
				}
			}
		}
	}
});

// Get the absolute value of a number (make it positive)
app.filter('absolute', function(){
    return function(number){
        return Math.abs(number);
    }
});

app.filter('userToBgColor', function(){
    return function(member, returnAsString){
        return Utils.userToBgColor(member, returnAsString);
    }
});

app.filter('stringToBackgroundColor', function () {
    return function (str) {
        return Utils.stringToBackgroundColor(str);
    }
});

app.filter('titleCase', function () {
    return function (str) {
        return str ? (`${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`): str;
    }
});

app.filter('getResumeLocalized', function () {
    return function (locations) {
        var countryCode = locations && locations[0] && locations[0].Country && locations[0].Country.code;

        if (countryCode == 'UK') {
            return $filter("translate")("CV");
        }

        return $filter("translate")("Resume");
    }
});


app.filter('getResumeLocalizedByBrandLocation', function () {
    return function (locations) {
        var countryCode = locations && locations && locations.country && locations.country.code;
        if (countryCode == 'UK') {
            return $filter("translate")("CV");
        }

        return $filter("translate")("resume");
    }
});

app.filter('wordsInitialChars', function(){
    return function(label){
        return Utils.getWordsInitialChars(label);
    }
});

app.filter('formatSSN', function(){
    return function (ssn) {
        if (ssn && ssn.length < 10) {
            var ssnNumber = ssn.slice(0, 3) + '-' + ssn.slice(3, 5) + '-' + ssn.slice(5, 10);
            return ssnNumber;
        }
        return ssn;
    }
});

app.filter('formatPHILID', function(){
    return function (phil_id) {
        if (phil_id && phil_id.length < 13) {
            var philIdNumber = phil_id.slice(0, 4) + '-' + phil_id.slice(4, 7) + '-' + phil_id.slice(7, 11) + '-' + phil_id.slice(11, 12);
            return philIdNumber;
        }
        return phil_id;
    }
});

app.filter('formatNINO', function(){
    return function (ni) {
        if (ni && ni.length < 10) {
            var niNumber = ni.slice(0, 2) + '-' + ni.slice(2, 8) + '-' + ni.slice(8, 10);
            return niNumber;
        }
        return ni;
    }
});

app.filter('starsFirst', function () {
    return function (phil_id) {
        var star = '*';
        if (phil_id) {
            phil_id = phil_id.replace(/[^0-9]+/g, '');
            if (phil_id.length < 13) {
                var philIdNumber = star.repeat(7) + phil_id.substring(7, 12);
                philIdNumber = philIdNumber.slice(0, 4) + '-' + philIdNumber.slice(4, 7) + '-' +  philIdNumber.slice(7, 11) + '-' + philIdNumber.slice(11, 12);
                return philIdNumber;
            }
        }

        return phil_id;
    }
});

app.filter('formatCPR', function(){
    return function (cpr) {
        if (cpr && cpr.length < 11) {
            var cprNumber = cpr.slice(0, 6) + '-' + cpr.slice(6, 10);
            return cprNumber;
        }
        return cpr;
    }
});

app.filter('starFirstOne', function () {
    return function (ssn) {
        var star = '*';
        if (ssn) {
            ssn = ssn.replace(/[^0-9]+/g, '');
            if (ssn.length < 10) {
                var ssnNumber = star.repeat(5) + ssn.substring(5, 10);
                ssnNumber = ssnNumber.slice(0, 3) + '-' + ssnNumber.slice(3, 5) + '-' + ssnNumber.slice(5, 10);
                return ssnNumber;
            }
        }

        return ssn;
    }
});

app.filter('starsFirst', function () {
    return function (phil_id) {
        var star = '*';
        if (phil_id) {
            phil_id = phil_id.replace(/[^0-9]+/g, '');
            if (phil_id.length < 13) {
                var philIdNumber = star.repeat(7) + phil_id.substring(7, 12);
                philIdNumber = philIdNumber.slice(0, 4) + '-' + philIdNumber.slice(4, 7) + '-' +  philIdNumber.slice(7, 11) + '-' + philIdNumber.slice(11, 12);
                return philIdNumber;
            }
        }

        return phil_id;
    }
});

 const calculatePolygonPoints = (center, radius, numSides) => {
    const points = [];
    const lat = center.latitude * Math.PI / 180; // Convert to radians
    const lng = center.longitude * Math.PI / 180; // Convert to radians
    const d = radius / 6378137; // Earth's radius in meters

    for (let i = 0; i <= numSides; i++) {
        const angle = i * 2 * Math.PI / numSides;
        const latRadians = Math.asin(Math.sin(lat) * Math.cos(d) + Math.cos(lat) * Math.sin(d) * Math.cos(angle));
        const lngRadians = lng + Math.atan2(Math.sin(angle) * Math.sin(d) * Math.cos(lat), Math.cos(d) - Math.sin(lat) * Math.sin(latRadians));
        points.push([(latRadians * 180 / Math.PI).toFixed(6), (lngRadians * 180 / Math.PI).toFixed(6)]);
    }
    return points;
}

app.filter('googleStaticMap', function () {
    return function (data) {
        var locations = data.locations;
        var color = (data.color && '0x' + data.color.substring(1, data.color.length)) || '0x0088DD';
        var isMobile = window.matchMedia("only screen and (max-width: 780px)");

        var mapHeight, mapWidth;

        if (isMobile.matches) {
            mapHeight = 300;
            mapWidth = $(window).width() - 100;
        } else {
            mapHeight = 600;
            mapWidth = $(window).width();
        }

        var googleStaticMapsURL = "https://maps.googleapis.com/maps/api/staticmap";


        var params = {
            key: publicConfiguration.keys.google.services,
            size: mapWidth + "x" + mapHeight,
            scale: 2,
            maptype: "roadmap",
            style: [
                "feature:all|element:geometry.fill|color:0xD2EAFA",
                "feature:all|element:geometry.stroke|color:0xC2E3F6|weight:1",
                "feature:all|element:labels.text|color:0x699fda",
                "feature:all|element:labels.text.stroke|visibility:off",

                "feature:road|element:geometry.fill|color:0xFFF3AF|lightness:0",
                "feature:road|element:geometry.stroke|color:0xC2E3F6|lightness:0",
                "feature:road|element:labels.text.fill|color:0x5793d4",

                "feature:administrative|element:geometry.fill|color:0xD2EAFA",

                "feature:landscape|element:geometry.fill|color:0xF8F9FA",
                "feature:landscape|element:geometry.stroke|color:0xC2E3F6|weight:1",

                "feature:poi|element:labels.text|color:0x86CEF9|weight:1|visibility:simplified",
                "feature:poi|element:labels.icon|color:0xFEA06B|visibility:simplified",
            ]
        };

        var markers = [`color:${color}|size:mid`];
        const paths = [];

        for (const location of locations) {
            if (location) {
                const [label, latitude, longitude, radiusInMeters] = location;

                markers.push([latitude, longitude].join(","));
                if (radiusInMeters > 0) {
                    const circlePoints = calculatePolygonPoints({ latitude, longitude }, radiusInMeters, 30);
                    let path = `color:0x4A90E2|weight:1|fillcolor:0x4A90E2|`;
                    path += circlePoints.map(point => `${point[0]},${point[1]}`).join('|');
                    paths.push(path);
                }

            }
        }

        params['markers'] = markers.join("|");
        params['path'] = paths.join("&path="); // Combine all paths for multiple circles

        return googleStaticMapsURL + "?" + $.param(params, true);
    }
});

app.filter('currencyCodeToSymbol', function () {
    return function (currencyCode) {
        currencyCode = currencyCode || 'USD';

        switch (currencyCode){
            case 'USD':
                return '$';
                break;
            case 'GBP':
                return '£';
                break;
            case 'EUR':
                return '€';
                break;
        }

        return currencyCode;
    }
});
app.filter('formatNumber', ['$filter', function($filter) {
    return function (number, format, symbol, value2) {

        var result = '';

        if (number === Infinity || isNaN(number)) {
            return '-';
        }

        if (value2 != undefined) {
            if (format === 'CURRENCY') {
                result = $filter("currency")(value2, symbol).replace(".00", "") + ' (';
            }
            else if (format === 'PERCENTAGE') {
                result = Utils.roundFloat(value2, 2) + '%';
            }
            else if (format === 'NUMBER') {
                result = $filter('number')(value2, 2).replace('.00', '');
            }
            else {
                result = Utils.roundFloat(value2, 2) + ' (';
            }
        }

        switch (format){
            case 'PERCENTAGE':
                if (value2 == undefined) {
                    result += Utils.roundFloat(number, (value2 != undefined) ? 0 : 2) + '%';
                }
                break;
            case 'CURRENCY':
                if (value2 == undefined) {
                    result += $filter("currency")(number, symbol).replace(".00", "");
                }
                else {
                    result += Utils.roundFloat(number, 2);
                }
                break;
            default:
                result += Utils.roundFloat(number, 2);
                break;
        }

        if (value2 != undefined && format != 'PERCENTAGE') {
            result += '%)';
        }

        return result;
    }
}]);

app.filter('formatDurationWithText', function () {
    return function (time) {

        if (time) {
            var hours = Math.floor(time / 3600);
            var minutes = Math.floor((time % 3600) / 60);
            minutes = minutes < 10 && minutes !== 0 ? '0' + minutes : minutes;
            var value = hours + "hr " + minutes + "min";
            return value;
        }

        return "0hr 0min";
    }
});

app.filter('hCurrency', [function() {
    return function (amount, currencySymbol, fractionSize) {
        return Utils.hCurrency(amount, currencySymbol, fractionSize);
    }
}]);

app.filter('urlize', [function(text) {
    return function (text) {
        if (!text) {
            return '';
        }
        var trimText = text.toLowerCase().trim();
        return trimText.replace(/[^a-zA-Z_0-9_\-.]+/g, " ").replace(/\ /g, "-");
    }
}]);

app.filter('satisfactionIcon', [function() {
    return function (score) {
        if(score >= 0 && score < 30){
            return '../images/satisfaction/very-dissatisfied.svg';
        }
        if(score >= 30 && score < 60){
            return '../images/satisfaction/somewhat-dissatisfied.svg';
        }
        if(score >= 60 && score < 80){
            return '../images/satisfaction/somewhat-satisfied.svg';
        }
        if(score >= 80){
            return '../images/satisfaction/very-satisfied.svg';
        }
    }
}]);


app.filter('satisfactionColor', [function() {
    return function (score) {
        if(score >= 0 && score < 30){
            return '#E02020';
        }
        if(score >= 30 && score < 60){
            return '#FEC023';
        }
        if(score >= 60 && score < 80){
            return '#2CE3A0';
        }
        if(score >= 80){
            return '#4CAF50';
        }
    }
}]);

app.filter('hChartsNumber', ['$filter', function ($filter) {
    return function (value, options) {

        options = $.extend({
            "prefix": "",
            "suffix": "",
            "currency": "",
            "compact": true,
            "fractions": 2,
            "format": formatter
        }, options);

        function formatter(value, options) {

            if (isNaN(value) || value === null) {
                return '';
            }

            var result = value;

            if (options['compact']) {
                result = Utils.compactNumber(value, options['currency']);
            }
            else if (options['currency']) {
                result = Utils.hCurrency(value, options['currency'], options['fractions']);
            }
            else {
                result = $filter('number')(value, options['fractions']).replace(".00", "").replace(/\.0$/, "");
            }

            var resultParts = [];

            options['prefix'] && resultParts.push(options['prefix']);
            resultParts.push(result);
            options['suffix'] && resultParts.push(options['suffix']);

            if (options['withoutSpace']) {
                return resultParts.join('');
            }

            return resultParts.join(' ');
        }

        return options.format(value, options);
    };
}]);


if (typeof window != "undefined") {
    window.globalFilters = globalFilters;
    $filter = window.$filter;
}

/******** KEEP THIS AT THE END OF THE FILE PLEASE *********/
// Export to backend
if (typeof module !== 'undefined') {
    module.exports = globalFilters;
}
